import { render, staticRenderFns } from "./ChildComp.vue?vue&type=template&id=ec3a1ee4&"
import script from "./ChildComp.vue?vue&type=script&lang=js&"
export * from "./ChildComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports